import React from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'
import { graphql, compose } from 'react-apollo'

import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'

import { Link } from 'react-router-dom'
import { withFormik } from 'formik'
import * as yup from 'yup'
import { withSnackbar } from 'notistack'

import { isMobile } from '../../utils'
import { styles } from './styles'
import { REQUEST_RESET_PASSWORD } from '../../graphql/mutations'

const endpoint = process.env.REACT_APP_API_ENDPOINT

const validationSchema = () => {
  /* istanbul ignore next */
  return yup.object().shape({
    email: yup.string().email().required()
  })
}

export const handleSubmit = async (values, { props, setSubmitting }) => {
  const { email } = values
  const { enqueueSnackbar, history } = props

  setSubmitting(true)

  try {
    const data = {
      email
    }
    await axios.post(endpoint + `/hero/forgotPassword`, data)
    history.replace('/check-email')
  } catch (error) {
    enqueueSnackbar(error.response.data.message)
  }

  setSubmitting(false)
}

export const ForgotPassword = ({
  handleSubmit,
  handleChange,
  handleBlur,
  touched,
  errors,
  isSubmitting
}) => {
  return (
    <main style={styles.main}>
      <Paper elevation={isMobile ? 0 : 1} square style={styles.paper}>
        <Typography id="titlePage" variant="h5">
          ลืมรหัสผ่าน
        </Typography>

        <form onSubmit={handleSubmit}>
          <FormControl
            margin="normal"
            fullWidth
            error={touched.email && Boolean(errors.email)}>
            <TextField
              id="inputEmail"
              type="text"
              name="email"
              label="อีเมล (Email)"
              onChange={handleChange}
              onBlur={handleBlur}
              error={touched.email && Boolean(errors.email)}
            />
            {touched.email && errors.email && (
              <FormHelperText>{errors.email}</FormHelperText>
            )}
          </FormControl>
          {isSubmitting ? (
            <Button disabled fullWidth style={styles.button}>
              กำลังรีเซ็ตรหัสผ่าน...
            </Button>
          ) : (
            <Button
              variant="contained"
              id="btnSubmit"
              type="submit"
              color="primary"
              fullWidth
              style={styles.button}>
              รีเซ็ตรหัสผ่าน
            </Button>
          )}
        </form>
      </Paper>
      <div
        style={{
          marginTop: '1em'
        }}>
        <Button id="btnLogin" color="primary" fullWidth>
          <Link href="#" to="/" style={styles.link}>
            กลับสู่หน้าแรก
          </Link>
        </Button>
      </div>
    </main>
  )
}

ForgotPassword.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  isSubmitting: PropTypes.bool.isRequired
}

export default compose(
  withSnackbar,
  graphql(REQUEST_RESET_PASSWORD, { name: 'RequestResetPassword' }),
  withFormik({
    enableReinitialize: true,
    mapPropsToValues: ({ me }) => {
      return {
        email: ''
      }
    },
    handleSubmit,
    validationSchema,
    displayName: 'ForgotPasswordForm'
  })
)(ForgotPassword)



// WEBPACK FOOTER //
// ./src/pages/ForgotPassword/index.js